export default "__VITE_ASSET__BqAcqa_r__"